import { apiClient } from '../../api/index';

// GET /public/sponsorships (prefix resolved by VITE_APP_BACKEND_SERVICE env var
// set at build time — /service/api/v1 in dev, /product/api/v1 in UAT/prod).
// Follows the same pattern as addFavService, businessService, reviewService, etc.
export interface PublicSponsorship {
  _id: string;
  listingId: string;
  pinned?: boolean;
  packageName?: string;
}

const SERVICE_ENDPOINT = import.meta.env.VITE_APP_BACKEND_SERVICE;

export const fetchPublicSponsorships = async (): Promise<
  PublicSponsorship[]
> => {
  const { data } = await apiClient.get(
    `${SERVICE_ENDPOINT}/public/sponsorships`
  );
  return Array.isArray(data) ? data : (data?.data ?? []);
};

// POST /sponsorships/:id/track
// Body: { kind: 'impression' | 'click' }
// Fire-and-forget — best-effort, failures are silently swallowed by callers.
export const trackSponsorshipEvent = async (
  sponsorshipId: string,
  kind: 'impression' | 'click'
): Promise<void> => {
  try {
    await apiClient.post(
      `${SERVICE_ENDPOINT}/sponsorships/${encodeURIComponent(sponsorshipId)}/track`,
      { kind }
    );
  } catch {
    // fire-and-forget — never break the UI for tracking failures
  }
};
